import { EnquiryLifecycleStatusEnum } from "../enum";

export class EnquiryAssessmentInfoReq{
    status: EnquiryLifecycleStatusEnum;
    enquiryNumber:string;
    country:number;
    destination: number;
    unit:number;
    createdUser: string;
    fromDate: any;
    toDate: any;
    tabName: string

    constructor(status: EnquiryLifecycleStatusEnum,enquiryNumber:string,country:number,destination: number,unit:number,createdUser: string,fromDate: any,toDate:any,tabName: string){
    this.status = status
    this.enquiryNumber = enquiryNumber
    this.country = country
    this.destination = destination
    this.unit = unit
    this.createdUser = createdUser
    this.fromDate = fromDate
    this.toDate = toDate
    this.tabName = tabName
    }
}